// Texto 29 (item 2, REGRAS 1.4): a faixa de ações da seleção fica FIXA embaixo da tela (no lugar da barra de abas),
// enquanto houver itens selecionados. Quem seleciona (useSelecao) registra aqui as ações; a barra de baixo desenha.
import { useSyncExternalStore } from 'react';

export type AcaoFaixa = { label: string; onPress: () => void; cor?: string; desativada?: boolean };
export type Faixa = { acoes: AcaoFaixa[]; cor: string; aviso?: string };
let atual: { dono: string; f: Faixa } | null = null;
let versao = 0;
const ouvintes = new Set<() => void>();
const avisar = () => { versao++; ouvintes.forEach(f => f()); };

export function mostrarFaixa(dono: string, f: Faixa | null) {
  if (!f) { if (atual?.dono === dono) { atual = null; avisar(); } return; }
  atual = { dono, f }; avisar();
}
export function useFaixaSelecao(): Faixa | null {
  useSyncExternalStore(cb => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; }, () => versao);
  return atual?.f ?? null;
}
